import React from 'react';
import flordaisies from '../assets/florDaisiesSF.png';

/**
 * GlobalLoader - Reusable loading component with spinning flower animation.
 * 
 * @param {string} title - Main loading title (default: "Cargando")
 * @param {string} subtitle - Subtitle text (default: "Por favor espera un momento...")
 * @param {boolean} overlay - If true, renders as fixed full-screen overlay with blur backdrop.
 *                            If false, renders inline centered within parent container.
 */
const GlobalLoader = ({ 
  title = 'Cargando', 
  subtitle = 'Por favor espera un momento...', 
  overlay = true 
}) => {
  const content = (
    <div className="bg-white p-8 rounded-card shadow-elevated flex flex-col items-center">
      <div className="w-20 h-20 mb-6 animate-spinSlow">
        <img 
          src={flordaisies} 
          alt="Cargando..." 
          className="w-full h-full object-contain"
        />
      </div>
      <h3 className="text-xl font-semibold text-text-primary mb-2 tracking-tight">{title}</h3>
      <p className="text-text-secondary text-center text-sm">
        {subtitle}<br/>
        <span className="text-daisies mt-2 inline-block ds-caption">Por favor espera un momento...</span>
      </p>
    </div>
  );

  if (overlay) {
    return (
      <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center">
        {content}
      </div>
    );
  }

  // Inline mode: centered within a flex container
  return (
    <div className="flex flex-col items-center justify-center py-12">
      {content}
    </div>
  );
};

export default GlobalLoader;
